import Assert from "tbAssert";

function SortAsComparer(lhs, rhs) {
    Assert.StrictAssert("sortAs" in lhs, "SortAsComparer called on lhs object without sortAs property");
    Assert.StrictAssert("sortAs" in rhs, "SortAsComparer called on rhs object without sortAs property");

    let sortLhs = lhs.sortAs;
    let sortRhs = rhs.sortAs;
    if (sortLhs < sortRhs) {
        return -1;
    }
    if (sortLhs > sortRhs){
        return 1;
    }
    return 0;
}

export default SortAsComparer;



//////////////////
// WEBPACK FOOTER
// ./src/utility/SortAsComparer.js
// module id = JGwZ
// module chunks = 1